// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by jcanales - 26/07/2023

import { Component } from '@angular/core'
import { BaseController } from './base.controller';
import { Action, ComponentService, CtFormComponent, CtInputTextComponent, CtOtpComponent, TwoFactorAuthentication } from 'components';

@Component({
	selector: 'ex-vi21',
	template: `<div [id]="getId()" #target><div>`
})

export class ExVi21 extends BaseController {

	constructor() {
		super();
		this.setViewCode('EX_VI21');
	}

	/* ---------------------- CONTROLLER LOGIC ------------------- */

	/**
	 * Ejemplos para el seteo de datos en el componente CtOtpComponent por medio de controlador o desde UTL
	 * @param action desde el EDITOR
	 */
	public setDataToOtp(action : Action): void {

		const typeOfExecution : string = 'UTL ACTION'

		//directamente desde el controlador (a pata)
		if(typeOfExecution === 'CONTROLADOR'){
			const contact : string = this.utilService.getComponentRef(action.conditionParams[0]).getValue();
			const type : string = this.utilService.getComponentRef(action.conditionParams[1]).getValue();
			const userIdentifier : string = this.utilService.getComponentRef(action.conditionParams[2]).getValue();
			const otpComponent : CtOtpComponent = this.utilService.getComponentRef(action.conditionParams[3]);
			otpComponent.setContactVerify(contact);
			otpComponent.setNotificationTarget(type === 'EMAIL' ? TwoFactorAuthentication.EMAIL : TwoFactorAuthentication.PHONE);
			otpComponent.setUserIdentifier(userIdentifier);
		}
		//desde UTL por medio de action
		else if(typeOfExecution === 'UTL ACTION'){
			this.componentService.utl_set_otp_data(action);
		} 
		//desde UTL por medio de parametros
		else {
			const formComponent : CtFormComponent = this.utilService.getComponentRef(action.conditionParams[1]);
			this.componentService.utl_set_otp_data(
				null,
				action.conditionParams[0],
				formComponent.getFormElementByModelId('CONTACT_VERIFY').getValue(),
        		formComponent.getFormElementByModelId('NOTIFICATION_TARGET').getValue(),
        		formComponent.getFormElementByModelId('USER_IDENTIFIER').getValue());
		}
	}
	/* -------------------- END CONTROLLER LOGIC ----------------- */

}